var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item)?_c('v-chip',{staticClass:"white--text",attrs:{"x-small":"","color":_vm.get_color(_vm.item),"label":""}},[_vm._v(_vm._s(_vm.item.attendence == "P" ? "P" : _vm.item.attendence)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }